import { ApplicationInsights } from '@microsoft/applicationinsights-web';

// Matches the runtime-config lookup in msalConfig.js / bffBaseUrl.js: window._env_
// is injected per-environment by server.js, process.env is the build-time fallback.
const getEnv = (key) =>
  (typeof window !== 'undefined' && window._env_ ? window._env_[key] : undefined)
  ?? process.env[key];

const instrumentationKey = getEnv('REACT_APP_AZURE_APP_INSIGHTS_KEY') || '';

// Without a key the SDK still POSTs to /v2/track and every call 400s, which is
// just console noise locally — so only start it when it can actually report.
export const appInsights = process.env.NODE_ENV !== 'test' && instrumentationKey
  ? new ApplicationInsights({
    config: {
      instrumentationKey,
      // 'unload' is deprecated and, like 'beforeunload', makes the page
      // ineligible for the back/forward cache. pagehide + visibilitychange
      // remain hooked, so telemetry is still flushed on navigation away.
      disablePageUnloadEvents: ['unload', 'beforeunload'],
    },
  })
  : null;

if (appInsights) {
  appInsights.loadAppInsights();
}

const logger = {
  log: (message, data = {}) => {
    console.log(message, data);
    if (appInsights) {
      appInsights.trackTrace({ message, properties: data });
    }
  },

  error: (message, error = {}) => {
    console.error(message, error);
    if (appInsights) {
      appInsights.trackException({ exception: error, properties: { message } });
    }
  },

  event: (eventName, properties = {}) => {
    if (appInsights) {
      appInsights.trackEvent({ name: eventName, properties });
    }
  },
};

export default logger;
